window.TechTrackMap = class TechTrackMap {
    constructor() {
        this.mapper = new MapperEsri();
        this.layers = {
            technician: 'technicianLayer',
            target: 'targetLayer'
        };

        this.technicianId = "technician";
        this.targetId = "target";

        this.technicianImg = '/Assets/Media/Icons/Track/Technician.png';
        this.targetImg = '/Assets/Media/Icons/Track/Target.png';
        this.technicianArrivedImg = '/Assets/Media/Icons/Track/TechnicianArrived.png';

        this.watchUtils = null;
    }

    async initialize(mapDivId) {
        const result = await esriLoader.loadModules([
            "esri/core/watchUtils"
        ]).catch(() => Promise.reject());

        this.watchUtils = result[0];

        await this.mapper.initializeMapView(mapDivId, {
            layers: Object.values(this.layers).map(layer => { return { id: layer } }),
            canOpenFullscreenMap: true
        }, "4.10");

        this._centerWhenIdle();
    }

    _centerWhenIdle() {
        const timerDelay = 10 * 1000;
        let timerId = setInterval(() => this.center(), timerDelay);

        this.watchUtils.whenTrue(this.mapper.view, "stationary", () => {
            clearInterval(timerId);
            timerId = setInterval(() => this.center(), timerDelay);
        });
    }

    center() {
        const points = [];

        const technicianGraphic = this.mapper.graphicsLayerGetGraphic(this.layers.technician, this.technicianId);
        const targetGraphic = this.mapper.graphicsLayerGetGraphic(this.layers.target, this.targetId);

        [technicianGraphic && technicianGraphic.geometry, targetGraphic && targetGraphic.geometry]
            .forEach(function (point) {
                if (!point || !point.latitude || !point.longitude
                    || points.find(p => p.latitude === point.latitude && p.longitude === point.longitude)) {
                    return;
                }

                points.push(point);
            });

        if (points.length === 0) {
            return;
        }

        if (points.length > 1) {
            this.mapper.setExtent(points);
        } else {
            this.mapper.centerAt(points[0]);
            this.mapper.setZoom(15);
        }
    }

    updateTechnicianMarker(coords, iconUrl) {
        this._updateMarker(this.layers.technician, this.technicianId, coords, iconUrl || this.technicianImg, '50px', '50px');
    };

    updateTargetMarker(coords) {
        this._updateMarker(this.layers.target, this.targetId, coords, this.targetImg, '21px', '41px');
    }

    _updateMarker(layerId, featureId, coords, iconUrl, width, height) {
        if (!coords) {
            this.mapper.graphicsLayerRemoveGraphic(layerId, featureId);
            return;
        }

        const graphic = this.mapper.graphicsLayerGetGraphic(layerId, featureId);

        const geometry = {
            latitude: coords.Latitude,
            longitude: coords.Longitude,
        };

        const symbol = {
            type: 'picture-marker',
            url: iconUrl,
            width: width || '36px',
            height: height || '36px'
        };

        // We need to set attributes.id if we want to search for the feature later
        const attributes = {
            id: featureId
        };

        graphic
            ? this.mapper.updateGraphicProperties(graphic, { geometry, symbol })
            : this.mapper.graphicsLayerAddGraphics(layerId, this.mapper.createGraphic(geometry, attributes, symbol));
    }
};